import {
  CollectorInstallStatus,
  CollectorSettingScope,
  CollectorSettingsUnifiedQuery
} from 'graphql/types';
import { CollectorInstallInfo } from './AllCollectorsTab';

export enum SyncStatus {
  completed = 'Completed',
  inProgress = 'InProgress',
  failed = 'Failed',
  partiallyCompleted = 'PartiallyCompleted'
}

export enum CollectorCategory {
  Browser = 'Browser'
}

export const settingObjCollector = (
  userSettingData: CollectorSettingsUnifiedQuery | undefined
): Record<string, CollectorInstallInfo> => {
  return (userSettingData?.collectorSettings?.items || []).reduce((acc, i) => {
    if (i?.collectorId && !acc[i?.collectorId])
      acc[i?.collectorId] = {} as CollectorInstallInfo;

    if (i?.scope === CollectorSettingScope.User && i?.collectorId) {
      acc[i?.collectorId]['userInstallationDetails'] = i?.maintainers;
      acc[i?.collectorId]['userInstallationDate'] = i?.installedDate;
      acc[i?.collectorId]['userSettings'] = i?.settings;
      acc[i?.collectorId][
        'userInstallStatus'
      ] = i?.installStatus as CollectorInstallStatus;
    } else if (i?.scope === CollectorSettingScope.Tenant && i?.collectorId) {
      acc[i?.collectorId]['tenantInstallationDetails'] = i?.maintainers;
      acc[i?.collectorId]['tenantInstallationDate'] = i.installedDate;
      acc[i?.collectorId]['tenantSettings'] = i.settings;
      acc[i?.collectorId][
        'tenantInstallStatus'
      ] = i.installStatus as CollectorInstallStatus;
    }

    return acc;
  }, {} as Record<string, CollectorInstallInfo>);
};
